'use client';

import React from 'react';
import { useSuperFlowClient } from '../../../../../libs/logger/useSuperFlowClient';
import type { Config } from 'u-next/config';

export const MobileBanner: React.FC<{ config: Config }> = ({ config }) => {
  const { isReadyToSend, trackUserClickLog } = useSuperFlowClient(config);

  const handleClick = () => {
    if (!isReadyToSend) return;

    trackUserClickLog({
      target: 'xxxxxx-footer-mobileBanner',
      detail: { source_url: window.location.href },
    });
  };

  return (
    <div className="cst-side-space max-w-180">
      <a
        href="https://t.unext.jp/r/unext_mobile_mypage_footer"
        target="_blank"
        rel="noopener noreferrer"
        className="block overflow-hidden rounded-3"
        onClick={handleClick}
      >
        <img
          src="https://metac.nxtv.jp/img/static_resource/img/pr/mobile_set_sp.png"
          alt=""
          width="800"
          height="200"
          className="block w-full lg:hidden"
        />
        <img
          src="https://metac.nxtv.jp/img/static_resource/img/pr/mobile_set_pc.png"
          alt=""
          width="2000"
          height="250"
          className="hidden w-full lg:block"
        />
      </a>
    </div>
  );
};
